<template>
  <div class="AddNewFund">
    <q-form @submit="SaveTIN" class="q-gutter-md">
        <div class="row">
            <div class="col">
                <!-- <q-input color="primary" :value="object.val" @input="onInput($event)" float-label="Country of Tax Residence">
				          <q-autocomplete @search="search"/>
                </q-input> -->
                {{$t("Fatca-Detail.countryofTaxResidence")}}
                <q-select
                  outlined lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"
                  behavior="menu"
                  filter
                  v-model="TaxResidency_Country"
                  ref="CountrySelection"
                  v-on:input="onInput($event)"
                  :options="StoreStateLookup.Country_LK"
                />
            </div>
        </div>
        <div class="row" v-if="TaxResidency_IsTINUnavailable===false">
            <div class="col">
              TIN
                <q-input outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']"  v-model="TaxResidency_TIN" color="primary" />
            </div>
        </div>

        <div class="row">
            <div class="col">
                <q-toggle
                    v-model="TaxResidency_IsTINUnavailable"
                    :label='$t("Fatca-Detail.tinUnavailable")'
                    color="green-14"
                    style="height: 56px; margin-bottom: 20px; width: 100%; border: 1px solid #c2c2c2; border-radius: 0.5rem; padding-left: 5px;"
                />
            </div>
        </div>
        <div class="row" v-if="TaxResidency_IsTINUnavailable===true">
          <div class="col">
            <!-- {{$t("Fatca-Detail.tinUnavailableWhy")}} -->
            TIN Unavailable Reason
              <q-select
                outlined lazy-rulesss :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']"
                color="primary"
                behavior="menu"
                v-model="TaxResidency_UnavailableReason"
                :options="StoreStateLookup.UnavailableTINReason_LK"
              />
          </div>
        </div>
        <div class="row" v-if="TaxResidency_UnavailableReason.value==='B' && TaxResidency_IsTINUnavailable===true">
            <div class="col">
                Please elaborate on the selection above
                <q-input outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']" v-model="TaxResidency_ReasonB" color="primary"/>
            </div>
        </div>
        <br>
        <div class="row float-right" style="margin-bottom: 1.5rem;">
            <div class="col">
                <q-btn 
                  flat
                  color="grey" 
                  @click="CloseModal" 
                  label="Close" 
                  class="q-ml-sm"
                /> 
               <q-btn
                  type="submit"
                  label="Save"
                  class="q-ml-sm"
                  style="background: #ff6666 !important; color: white !important;"
                />
            </div>
        </div>
      </q-form>
  </div>
</template>

<script>
import store from '../store';
import LookUp from '../assets/json/FieldsLookUp.json'
import {mapState} from 'vuex'
export default {
  name: 'SaveTIN',
  props: ['TINModal','UpdateTINModal','Status','SelectedTINId'],
  data () {
    return {
        StoreStateFATCA : store.state.FATCA,
        StoreStateLookup : store.state.Lookup,
        Id : '',
        TaxResidency_Country : '',
        TaxResidency_CountryName : '',
        TaxResidency_TIN : '',
        TaxResidency_IsTINUnavailable : false,
        TaxResidency_UnavailableReason : '',
        TaxResidency_ReasonB : '',
        Country_LK : this.parseCountries(),
        TaxResidency_UnavailableReason_LK : LookUp.UnavailableTINReason_LK,
        object : ''
    }
  },
	mounted () {
      this.CreateTempId();
	},
  methods: {
    
      
    onInput(item) { 
      for(var i=0;i<this.StoreStateLookup.Country_LK.length;i++){
        if(item.value===this.StoreStateLookup.Country_LK[i].value){

          this.object = { val : this.StoreStateLookup.Country_LK[i].label}
          this.TaxResidency_Country = this.StoreStateLookup.Country_LK[i].value;
          this.TaxResidency_CountryName = this.StoreStateLookup.Country_LK[i].label;
        }
      }
    },
    SaveTIN(){
      if(this.Status==='New'){
        if(this.StoreStateFATCA.TaxResidencyTIN.length<6){
          if(this.TaxResidency_Country=="") {
                  this.$q.notify({
                      message: 'You need to select Country of Tax Residence',
                      color: 'red'
                  })
                  return false;
            }

            if(this.TaxResidency_IsTINUnavailable== true){
              if(this.TaxResidency_UnavailableReason==""){
                  this.$q.notify({
                      message: 'TIN Unable Reason cannot be empty!',
                      color: 'red'
                  })
                  return false;
              }else if(this.TaxResidency_UnavailableReason!=""){
                  if(this.TaxResidency_UnavailableReason=='B'){
                    if(this.TaxResidency_ReasonB==""){
                      this.$q.notify({
                          message: 'Reason B cannot be Empty!',
                          color: 'red'
                      })
                       return false;
                    }
                  }
              }

            }else if (this.TaxResidency_IsTINUnavailable== false){
              if(this.TaxResidency_TIN ==""){
                  this.$q.notify({
                      message: 'TIN cannot be empty!',
                      color: 'red'
                  })
                  return false;
              }
            }

          this.StoreStateFATCA.TaxResidencyTIN.push(
            {
              Id : this.Id,
              TaxResidency_Country : this.TaxResidency_Country,
              TaxResidency_CountryName : this.TaxResidency_CountryName,
              TaxResidency_TIN : this.TaxResidency_TIN,
              TaxResidency_IsTINUnavailable : this.TaxResidency_IsTINUnavailable,
              TaxResidency_UnavailableReason : this.TaxResidency_UnavailableReason.value,
              TaxResidency_ReasonB : this.TaxResidency_ReasonB
            }
          )
          
        }
        else{
          this.$q.dialog({
          title: 'Warning',
          message: 'You have reach maximum to add new TIN'
        })
        }
      }
      else if(this.Status==='Update'){
        if(this.TaxResidency_Country=="") {
                  this.$q.notify({
                      message: 'You need to select Country of Tax Residence',
                      color: 'red'
                  })
                  return false;
            }

            if(this.TaxResidency_IsTINUnavailable== true){
              if(this.TaxResidency_UnavailableReason==""){
                  this.$q.notify({
                      message: 'TIN Unable Reason cannot be empty!',
                      color: 'red'
                  })
                  return false;
              }else if(this.TaxResidency_UnavailableReason!=""){
                  if(this.TaxResidency_UnavailableReason=='B'){
                    if(this.TaxResidency_ReasonB==""){
                      this.$q.notify({
                          message: 'Reason B cannot be Empty!',
                          color: 'red'
                      })
                       return false;
                    }
                  }
              }

            }else if (this.TaxResidency_IsTINUnavailable== false){
              if(this.TaxResidency_TIN ==""){
                  this.$q.notify({
                      message: 'TIN cannot be empty!',
                      color: 'red'
                  })
                  return false;
              }
            }
        var TINDetails = {


             Id : this.Id,
              TaxResidency_Country : this.TaxResidency_Country,
              TaxResidency_CountryName : this.TaxResidency_CountryName,
              TaxResidency_TIN : this.TaxResidency_TIN,
              TaxResidency_IsTINUnavailable : this.TaxResidency_IsTINUnavailable,
              TaxResidency_UnavailableReason : this.TaxResidency_UnavailableReason.value,
              TaxResidency_ReasonB : this.TaxResidency_ReasonB
        };
        this.UpdateTIN(TINDetails);
      }
      this.CloseModal();
      
    },
    CreateTempId(){
      var Tlength = this.StoreStateFATCA.TaxResidencyTIN.length;
      var TId;
      if (Tlength == 0){
        TId = 1001;
      }
      else{
        TId = Number(this.StoreStateFATCA.TaxResidencyTIN[Tlength-1].Id) + 1;
      }
      for(var i=0;i<Tlength;i++){
        if (TId == this.StoreStateFATCA.TaxResidencyTIN[i].Id)
          TId = Number(this.StoreStateFATCA.TaxResidencyTIN[i].Id) + 1;
      }
      this.Id = TId;
    },
    CloseModal(event){
      this.TaxResidency_Country = '';
      this.TaxResidency_CountryName = '';
      this.object = '';
      this.TaxResidency_TIN = '';
      this.TaxResidency_IsTINUnavailable = '';
      this.TaxResidency_UnavailableReason = '';
      this.TaxResidency_ReasonB = '';
      if(this.Status==='New')
        this.$emit("updateTINModal", false) ;
      else if(this.Status==='Update')
        this.$emit("updateStatusUpdateTINModal", false);
    },
    UpdateTIN(Value) {
        store.commit('Update_TIN', Value);
    },
    search (terms, done) {
      setTimeout(() => {
        done(filter(terms, {field: 'label', list: this.StoreStateLookup.Country_LK}))
      }, 0)
    },
    parseCountries(){
      return LookUp.Countries.map(country => {
        return {
          label: country,
          value: country
        }
      })
    },
    Get_TIN(Id){
      var TINDetails = this.$store.getters.getTINById(Id);
      this.Id = TINDetails.Id;
      this.TaxResidency_TIN = TINDetails.TaxResidency_TIN;
      this.TaxResidency_Country = TINDetails.TaxResidency_Country;
      this.TaxResidency_CountryName = TINDetails.TaxResidency_CountryName;
      this.object = {val : TINDetails.TaxResidency_CountryName};
      this.TaxResidency_IsTINUnavailable = TINDetails.TaxResidency_IsTINUnavailable;
      if(TINDetails.TaxResidency_IsTINUnavailable!=''){

        this.TaxResidency_UnavailableReason = TINDetails.TaxResidency_UnavailableReason;
      }
      this.TaxResidency_ReasonB = TINDetails.TaxResidency_ReasonB;
    }
  }
    
}
</script>
